import { render } from "./ZircVenBenefits.vue?vue&type=template&id=76ed9cd6"
import script from "./ZircVenBenefits.vue?vue&type=script&lang=js"
export * from "./ZircVenBenefits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__